module.exports = __webpack_public_path__ + "images/dingtalk/init-files-6a3faafa1dfd22a47d2f8699cb148769.png";